<template>
  <Drawer placement="left" :closable="false" v-model="openPoint" width="280" draggable class="my-drawer" title="路线规划">
    <div id="pointList">
      <Input v-model="keyword" search placeholder="请输入关键字" @on-search="getList"></Input>

      <ul>
        <li @click="clickItem(item)" v-for="(item, index) in tableData" :key="index" :class="{ active: item.select }">
          <div>
            {{ item.name }}
          </div>
          <div>
            <Icon title="编辑" @click.stop="opemUpdate(item)" class="icon" type="md-checkmark-circle-outRounte" />
            <Icon title="删除" @click.stop="del(item)" class="icon" type="md-close" />
          </div>
        </li>
      </ul>
      <Row :gutter="10">
        <Col span="12">
        <Button long @click="checkAll" :disabled="selectData.length == 0" type="primary">取消选择</Button> </Col>
        <Col span="12">
        <Button long @click="openAdd" type="success">新增</Button></Col>
      </Row>
    </div>
    <Rounte ref="Rounte" v-if="openOut" @ok="open1" :outUse="true"></Rounte>
  </Drawer>
</template>
<script>
import Rounte from "../rule/ruleLine.vue";
export default {
  components: { Rounte },
  data() {
    return {
      openPoint: false,
      openOut: false,
      tableData: [],
      selectData: [],
      isAll: false,
      keyword: "",
      isLoad: false, //是否已经请求过列表
    };
  },
  methods: {
    open() {
      this.openPoint = true;
      if (!this.isLoad) {
        this.getList();
      }
    },
    open1() {
      this.openPoint = true;
      this.openOut = false;
      this.getList();
    },
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.rule + "/route/list",
        data: { keyword: this.keyword },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {

          data[i].select = false;
          data[i].hasItem = false;
        }
        //var data = [{ name: "11111" }];
        this.tableData = data;
        this.isLoad = true;
      });
    },
    getItem(row) {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.rule + "/route/item",
        data: { id: row.id },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          var data = res.data.data.coordList;

          row.coordList = data;
          this.$emit("lines", this.selectData);
        }
      });
    },
    push() {
      this.selectData = [];
      for (let i = 0; i < this.tableData.length; i++) {
   
        if (this.tableData[i].select) {
          this.selectData.push(this.tableData[i]);
          //如果还没详情
          if (!this.tableData[i].hasItem) {
            this.getItem(this.tableData[i]);
            this.tableData[i].hasItem = true;
          }
        }
      }

      this.$emit("lines", this.selectData);
    },
    clickItem(v) {
      v.select = !v.select;
      this.push();
    },
    checkAll() {
      for (const i in this.tableData) {
        this.tableData[i].select = false;
      }
      this.selectData = [];
      this.$emit("Rountes", this.selectData);
    },
    del(row, n) {
      if (row.select) {
        this.clickItem(row);
      }
      this.openPoint = false;
      this.openOut = true;
      setTimeout(() => {
        this.$refs.Rounte.del(row);
      }, 200);
    },
    //点击编辑按钮
    opemUpdate(row) {
      if (row.select) {
        this.clickItem(row);
      }
      this.isAdd = false;
      this.openPoint = false;
      this.openOut = true;
      setTimeout(() => {
        this.$refs.Rounte.opemUpdate(row);
      }, 200);
    },
    openAdd() {
      this.isAdd = true;
      this.openPoint = false;
      this.openOut = true;
      setTimeout(() => {
        this.$refs.Rounte.openAdd();
      }, 200);
    },
  },
  mounted() { },
};
</script>
<style lang="">
#pointList {
  height: 100%;
}
#pointList ul {
  height: calc(100% - 80px);
  margin: 10px auto;
  overflow: auto;
}
#pointList li {
  padding: 10px;
  cursor: pointer;
}
#pointList li.active {
  background: #d9ebfe;
}
</style>


// WEBPACK FOOTER //
// src/components/common/lineList.vue